import { useSelector, useDispatch } from "react-redux";
import InfoIcon from "@mui/icons-material/Info";
import {
  Stack,
  Typography,
  ProgressBar,
  Tooltip,
  IconButton,
  Divider,
  Button,
} from "@financeable-com-au/financeable-ui";
import { lenderCardsSelector, setLenderCardsTooltip, resetLenderCardsTooltip } from "@/store/slices/lenderCards";
import { useLenderCardContext } from "@/providers/LenderCardContextProvider";
import { useLenderCardCriteria } from "../hooks";

const CriteriaProgress = () => {
  const { product } = useLenderCardContext();
  const { criteriaCheckedPercentage, criteriaCheckedLength, criteriaTotalLength, criteriaStatus, criteraList } =
    useLenderCardCriteria();

  // Tooltip is open if the lenderId matches the product.lenderId and the type is criteria.
  const { tooltip } = useSelector(lenderCardsSelector);
  const dispatch = useDispatch();
  const isTooltipOpen = tooltip !== undefined && tooltip.lenderId === product?.lenderId && tooltip.type === "criteria";
  const handleClickTooltip = () => {
    if (isTooltipOpen) {
      dispatch(resetLenderCardsTooltip());
    } else {
      dispatch(
        setLenderCardsTooltip({
          lenderId: product?.lenderId,
          isOpen: true,
          type: "criteria",
        }),
      );
    }
  };
  const handleCloseTooltip = () => {
    dispatch(resetLenderCardsTooltip());
  };

  return (
    <Stack direction="row" alignItems="center" columnGap={2} maxWidth="350px">
      <Typography level="body-xs">Criteria</Typography>
      <ProgressBar value={criteriaCheckedPercentage} status={criteriaStatus} />
      <Typography level="body-xs" bold={true}>
        {criteriaCheckedLength}/{criteriaTotalLength}
      </Typography>
      {/* Tooltip of criteria list. */}
      <Tooltip
        open={isTooltipOpen}
        title={
          <Stack padding={2} flexDirection="column" rowGap={2}>
            <Typography level="body-sm" bold>
              {product?.lender ? `${product.lender}'s criteria` : "Criteria"}
            </Typography>
            <Divider />
            {criteraList.map(({ label, icon }) => (
              <Stack flexDirection="row" alignItems="center" columnGap={3} key={label}>
                {icon}
                <Typography level="body-xs">{label}</Typography>
              </Stack>
            ))}
            <Button onClick={handleCloseTooltip} variant="secondary" fullWidth>
              Close Panel
            </Button>
          </Stack>
        }
      >
        <IconButton
          aria-label="Tooltip"
          isRounded={true}
          size="sm"
          variant="inline"
          intent="neutral"
          onClick={handleClickTooltip}
        >
          <InfoIcon sx={{ fontSize: "1rem" }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export { CriteriaProgress };
